import { clone } from '../object/clone';
import { _findIndex } from './_findIndex';
import { _isArray } from './_isArray';
import { modelSplitter } from './modelSplitter';

/**
  Asigna un valor "value" al campo "scope[model]" sabiendo que model puede identificar arrays,... usar bracket notación,...
  *Atención: esa función modifica el objeto "scope" pasado en parametro de entrada.

  @param object El scope es el objeto que va ser actualizado
  @param string El modelo, ej. "CAB.LIN" o "CAB['LIN'][10]" o ...
  @param <> El valor que se va asignar, el tipo depende del dato
  @options object Opciones {isImmutable=true}
  @return undefined
 */

export function setValueToScope(scope, model, value, options = {}) {
  if (typeof scope !== 'object') {
    throw new Error('setValueToScope. scope debe ser un objeto');
  }

  const { isImmutable = true } = options;

  const splitted = modelSplitter(typeof model === 'undefined' ? '' : model);
  const len = splitted.length;

  const res = isImmutable ? clone(scope) : scope;
  let data = res;

  splitted.forEach((cur, i) => {
    if (i < len - 1) {
      data = isNotLastItem(cur, data);
    } else if (i === len - 1) {
      isLastItem(cur, data, value);
    }
  });

  return res;
}

function isNotLastItem(cur, data) {
  if (_isArray(cur)) {
    const index = _findIndex(cur);
    const field = cur.replace(/\[.*\]/, '');

    if (!data[field]) {
      data[field] = [];
    }

    if (!data[field][index]) {
      data[field][index] = {};
    }

    return data[field][index];
  }

  if (!data[cur]) {
    data[cur] = {};
  }

  return data[cur];
}

function isLastItem(cur, data, value) {
  if (_isArray(cur)) {
    const index = _findIndex(cur);
    const field = cur.replace(/\[.*\]/, '');

    if (!data[field]) {
      data[field] = [];
    }

    data[field][index] = value;
  } else {
    data[cur] = value;
  }
}
